// extracted by mini-css-extract-plugin
export default {"feeDetailsCard":"Overview_feeDetailsCard__LQ1Jr","feeCategory":"Overview_feeCategory__mBKgA","feeDetail":"Overview_feeDetail__474I5"};